/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  BucketData,
  BucketData$inboundSchema,
  BucketData$Outbound,
  BucketData$outboundSchema,
} from "./bucketdata.js";

export type PublicGCSConnection = {
  provider: "gcs";
  data: BucketData;
  credentials: { [k: string]: any };
};

/** @internal */
export const PublicGCSConnection$inboundSchema: z.ZodType<
  PublicGCSConnection,
  z.ZodTypeDef,
  unknown
> = z.object({
  provider: z.literal("gcs"),
  data: BucketData$inboundSchema,
  credentials: z.record(z.any()),
});
/** @internal */
export type PublicGCSConnection$Outbound = {
  provider: "gcs";
  data: BucketData$Outbound;
  credentials: { [k: string]: any };
};

/** @internal */
export const PublicGCSConnection$outboundSchema: z.ZodType<
  PublicGCSConnection$Outbound,
  z.ZodTypeDef,
  PublicGCSConnection
> = z.object({
  provider: z.literal("gcs"),
  data: BucketData$outboundSchema,
  credentials: z.record(z.any()),
});

export function publicGCSConnectionToJSON(
  publicGCSConnection: PublicGCSConnection,
): string {
  return JSON.stringify(
    PublicGCSConnection$outboundSchema.parse(publicGCSConnection),
  );
}
export function publicGCSConnectionFromJSON(
  jsonString: string,
): SafeParseResult<PublicGCSConnection, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PublicGCSConnection$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PublicGCSConnection' from JSON`,
  );
}
